import { render, staticRenderFns } from "./GeneraDictamen.vue?vue&type=template&id=0ad3f099&scoped=true"
import script from "./GeneraDictamen.vue?vue&type=script&lang=js"
export * from "./GeneraDictamen.vue?vue&type=script&lang=js"
import style0 from "./GeneraDictamen.vue?vue&type=style&index=0&id=0ad3f099&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad3f099",
  null
  
)

export default component.exports